import { useQuery } from "@tanstack/react-query";
import { fetchHealth } from "../api/get-health";

export function useHealth() {
  return useQuery({
    queryKey: ["health"],
    queryFn: fetchHealth,
  });
}
